import { useTranslation } from 'react-i18next';
import Loader from 'components/atoms/Loader';

import s from './styles.module.scss';
import { useFilter } from './filter/use-filter';

import type { FC } from 'react';

type Props = {
  count?: number;
  isLoading?: boolean;
};

export const PotentialPatientsCount: FC<Props> = (props) => {
  const { count, isLoading } = props;
  const { t } = useTranslation();
  const { filter } = useFilter();

  return (
    <div className={s['form-group']}>
      <div className={s['section-title']}>
        ⇄ {t('labels.transferablePatients')}
      </div>
      <div className={s['stats-box']} data-loading={isLoading}>
        {isLoading && (
          <div className={s['loader-container']}>
            <Loader />
          </div>
        )}
        <div className={s['stat-row']}>
          <span>{t('labels.numberOfAvailablePatients')}</span>
          <span className={s['stat-value']}>{count ?? '-'}</span>
        </div>
        <div className={s.divider} />
        <div className={s['stat-row']}>
          <span>{t('labels.numberOfSelectedPatients')}</span>
          <span className={s['stat-value']}>
            {filter.patientsCountToTransfer ?? 0}
          </span>
        </div>
      </div>
    </div>
  );
};
